( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( '.gform_confirmation_message' ).addClass( 'wysiwyg theme-one' );
      } );

      const truck = document.querySelector( '.mpf__big-ol-truck' );
      if ( truck ) {
        // Force a reflow before adding the class so the transition from
        // -left-full to is-active actually animates on page load
        requestAnimationFrame( () => {
          requestAnimationFrame( () => {
            truck.classList.add( 'is-active' );
          } );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
